
import {Component, Prop, Vue} from 'vue-property-decorator';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faCaretDown } from '@fortawesome/free-solid-svg-icons/faCaretDown';
import { faCaretUp } from '@fortawesome/free-solid-svg-icons/faCaretUp';
import MainNavItem from '@/components/MainNavItem.vue';

/** @ts-ignore */
library.add(faCaretDown, faCaretUp);

@Component({
    components: { MainNavItem, fa: FontAwesomeIcon },
})
export default class MainNav extends Vue {
    @Prop() private active!: string;

    private open = false;
}
